import React, { useCallback } from 'react';
import { ShortcutData } from '../../../../../API/pcDashboard/CustomViewsApi';
import { useLocation } from 'react-router-dom';
import { Label, MenuItem, Paragraph, IconArrowRight, IconEditOutline } from '@zillow/constellation';
import { useHistory } from 'react-router';
import { clientUrls } from '../../../../../ui-toolkit/rest/ClientUrlFactory';
import styled from 'styled-components';
import { useCustomViewsContext } from '../context/CustomViewsContext';

export const ShortcutMenuItem: React.FC<{ shortcut: ShortcutData; isEdit?: boolean }> = ({ shortcut, isEdit }) => {
  if (isEdit) {
    return <EditMenuItem shortcut={shortcut} />;
  }
  return <ReadMenuItem shortcut={shortcut} />;
};

const EditMenuItem: React.FC<{
  shortcut: ShortcutData;
}> = ({ shortcut }) => {
  const { setCustomViewsState } = useCustomViewsContext();
  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.stopPropagation();
      setCustomViewsState({
        isOpen: true,
        isEdit: true,
        isCreate: false,
        updatingView: shortcut,
        formikData: { dirty: false, isValid: false },
      });
    },
    [setCustomViewsState, shortcut]
  );

  return (
    <MenuItem onClick={onClick} icon={<IconEditOutline />}>
      <MenuItemContent shortcut={shortcut} />
    </MenuItem>
  );
};

const ReadMenuItem: React.FC<{ shortcut: ShortcutData }> = ({ shortcut }) => {
  const { resetContext } = useCustomViewsContext();
  const history = useHistory();
  const { search } = useLocation();
  const isActive = search === shortcut.search;

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.stopPropagation();
      if (isActive) {
        return;
      }
      history.push(`${clientUrls.urlFor.dashboard()}${shortcut.search}`);
      resetContext();
    },
    [history, isActive, resetContext, shortcut]
  );

  return (
    <MenuItem onClick={onClick} icon={<Icon isActive={isActive} />}>
      <MenuItemContent shortcut={shortcut} />
    </MenuItem>
  );
};

const MenuItemContent: React.FC<{ shortcut: ShortcutData }> = ({ shortcut: { name, keyboardKey, description } }) => (
  <div>
    <Label>{`${name} - Shortcut: ${keyboardKey}`}</Label>
    <Paragraph>{description}</Paragraph>
  </div>
);

const Icon: React.FC<{ isActive: boolean }> = ({ isActive }) => {
  if (isActive) {
    return <IconArrowRight />;
  }
  return <DivThirtyTwo />;
};

const DivThirtyTwo = styled.div`
  width: 32px;
`;
